










import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IDamage } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'damage-short',
  components: {},
})
export default class DamageShort extends mixins(BaseMixin) {
  @Prop({ type: Object, required: true })
  damage!: IDamage;

  @Prop({ type: Boolean, required: false, default: true })
  small!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  hovered!: boolean;

  get title() {
    return `Schaden von ${this.damage.customer}`;
  }
}
